import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function Contact() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 4,
        position: "relative",
      }}
    >
      {/* ✅ Back button top-left */}
      <IconButton
        onClick={() => navigate("/")}
        sx={{ position: "absolute", top: 16, left: 16 }}
      >
        <ArrowBackIcon />
      </IconButton>

      <Box
        sx={{
          maxWidth: 820,
          width: '100%',
          p: { xs: 3, md: 5 },
          borderRadius: 4,
          background: 'linear-gradient(180deg, rgba(255,255,255,0.78), rgba(248,250,252,0.6))',
          boxShadow: '0 12px 36px rgba(2,6,23,0.08)',
          border: '1px solid rgba(14,165,233,0.08)',
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)',
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#062a78', mb: 1 }}>
          Contact Us
        </Typography>
        <Typography variant="body1" sx={{ color: '#334155', lineHeight: 1.7 }}>
          Ezra General Services is committed to providing high-quality human
          capital management and inventory solutions.
        </Typography>

        <Typography variant="subtitle1" sx={{ mt: 3, fontWeight: 700, color: '#0b3a66' }}>
          📧 support@ezrageneral.com
        </Typography>
        <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: 700, color: '#0b3a66' }}>
          📞 +63 912 345 6789
        </Typography>
      </Box>
    </Box>
  );
}
